//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";

//modules
// import fabricjs from "fabricjs/fabricjs.module";

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import mediaSlider from "emun.media/media-slider";
import mediaGallery from "emun.media/media-gallery";
import mediaGalleryItem from "emun.media/media-gallery-item";
import mediaContainer from "emun.media/media-container";
// import mediaDetails from "emun.media/media-details";

//directives
// import mediaDetailsSections from "emun.media/media-details-sections";
// import mediaDetailsActions from "emun.media/media-details-actions";
// import mediaDetailsHeader from "emun.media/media-details-header";
// import mediaList from "emun.media/media-list";
// import mediaListGrid from "emun.media/media-list-grid";
// import mediaListCards from "emun.media/media-list-cards";

//states
// import MediaStates, { getStates } from "emun.media/media.states";

export const dependencies = [dropdown, collapse];

export const modules = {
  // fabricjs,
  // modals,
};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  mediaContainer,
    mediaSlider,
    mediaGallery,
  mediaGalleryItem
  // mediaDetails,
};

export const directives = {
  // mediaDetailsHeader,
  // mediaDetailsSections,
  // mediaDetailsActions,
  // mediaList,
  // mediaListGrid,
  // mediaListCards,
};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states: {
    // ...MediaStates,
    // ...getStates(null, "media"),
    // ...getStates(null, "media-admin"),
  },
};
